/**
 * In Audit API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const NotificationRecipientStrategy = {
    Admins: 'admins',
    Owner: 'owner',
    Creator: 'creator',
    CustomEmails: 'customEmails'
} as const;
export type NotificationRecipientStrategy = typeof NotificationRecipientStrategy[keyof typeof NotificationRecipientStrategy];

